import { focusCovers } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FocusCovers() {
  const [feature, ...rest] = focusCovers;

  return (
    <section id="focus" className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
        <SectionHeading
          kicker="COVER STORY"
          title="焦点封面精选"
          desc="用封面说话，挑出当下最抢眼的几张画面，每一张都对应一个正在被讨论的话题。"
        />

        <a
          href="#topics"
          className="group relative block w-full h-[360px] md:h-[480px] rounded-lg overflow-hidden bg-background-200"
        >
          <img
            src={feature.image}
            alt={feature.title}
            title={`${feature.title} 看料91焦点`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-6 md:p-10">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
              {feature.tag}
            </span>
            <h4 className="mt-4 font-heading font-black text-background-50 text-2xl md:text-4xl leading-tight max-w-3xl">
              {feature.title}
            </h4>
            <p className="mt-3 md:mt-4 text-background-100/85 text-sm md:text-base max-w-2xl leading-relaxed">
              {feature.desc}
            </p>
            <div className="mt-5 flex items-center gap-3 text-xs md:text-sm text-background-100/70">
              <span>{feature.meta}</span>
              <span className="w-1 h-1 rounded-full bg-background-100/50" />
              <span className="inline-flex items-center gap-1">
                阅读全文
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </div>
          </div>
        </a>

        <div className="mt-6 md:mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {rest.map((item) => (
            <a
              key={item.title}
              href="#topics"
              className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/80"
            >
              <div className="relative w-full h-[220px] md:h-[240px] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} 看料91热门`}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h4 className="font-heading font-bold text-foreground-950 text-base md:text-lg leading-snug">
                  {item.title}
                </h4>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <div className="mt-5 flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.meta}</span>
                  <span className="w-6 h-6 flex items-center justify-center text-primary-600 group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}